<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 头部顶部 -->
    <!-- <div class="header-top container-fuild hidden-xs">
      <div class="container">
        <div class="server pull-left">
          <span class="glyphicon glyphicon-earphone"></span>888-888-888
          <span class="glyphicon glyphicon-envelope"></span>liyunkun_11@163.com
          <span class="glyphicon glyphicon-time"></span>7x24小时为您服务
        </div>
        <div class="shejiao pull-right">
          <span class="glyphicon glyphicon-hand-right"></span>赶快联系我们吧！
          <span class="glyphicon glyphicon-hand-left"></span>
        </div>
      </div>
    </div> -->
    <!-- 电脑导航 -->
    <div class="header-nav container hidden-xs">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img src="@/assets/img/anteklogo.png" />
      </div>
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li id="btn1">
          <router-link to="/">{{ $t("home") }}</router-link>
        </li>
        <li id="btn2">
          <a>{{ $t("xmal") }}</a>
        </li>
        <li id="btn3">
          <a>{{ $t("services") }}</a>
        </li>
        <li id="btn4">
          <a>{{ $t("aboutus") }}</a>
        </li>
      </ul>
      <div class="header-nav-right" @click="selectI18('en')">
        <li :class="lang == 'en' ? 'langli pickli' : 'langli'">English</li>
      </div>
      <div class="header-nav-right" @click="selectI18('zh')">
        <li :class="lang == 'zh' ? 'langli pickli' : 'langli'">中文</li>
      </div>
    </div>
    <div id="box" class="showDropDownArea" v-show="showarea">
      <div class="contentArea">
        <div class="item-cont fl-row">
          <div
            v-for="(item, index) in navList"
            :key="index"
            class="fl-row lie-item"
          >
            <div
              v-show="index != 0"
              class="fl-col-center cellLeftIcon"
              style="margin-right: 35px; margin-top: 10px"
            >
              <img :src="item.img" alt="" />
              <div class="name-div">{{ item.name }}</div>
            </div>
            <div class="fl-col">
              <div v-for="(i, n) in item.children" :key="n" class="hang-item">
                <router-link :to="i.path">
                  <div class="text-div">
                    {{ i.name }}
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <div class="header-nav-m-logo">
        <img
          class="center-block"
          src="@/assets/img/antek_logo_white.png"
          alt="logo"
        />
      </div>
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        {{ menuName }}
        <div
          class="header-nav-m-menu-wrapper"
          data-toggle="collapse"
          data-target="#menu"
          @click="menuClick"
        >
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li
            v-for="(item, index) in navList"
            :key="index"
            :class="index == navIndex ? 'active' : ''"
            data-toggle="collapse"
            data-target="#menu"
          >
            <router-link :to="item.path">
              {{ item.name }}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <div class="navigation-down">
      <div class="nav-down-menu"></div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
export default {
  name: "Header",
  data() {
    return {
      showarea: false,
      lang: localStorage.getItem("locale"),
      navIndex: sessionStorage.getItem("navIndex")
        ? sessionStorage.getItem("navIndex")
        : 0,
      menuName: this.$t("home"),
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          name: this.$t("home"),
          path: "/",
          children: [],
        },
        {
          name: this.$t("xmal"),
          path: "/",
          img: require("@/assets/img/tabxm.png"),
          children: [
            {
              name: this.$t("chartership"),
              path: "/project_CharterShip",
            },
            {
              name: this.$t("charterplane"),
              path: "/project_CharterPlane",
            },
            {
              name: this.$t("ElectronicCigarette"),
              path: "/Project_ElectronicCigarette",
            },
            {
              name: this.$t("EngineeringProject"),
              path: "/Projct_Engineering",
            },
            {
              name: this.$t("Semiconductor"),
              path: "/Projct_Semiconductor",
            },
            {
              name: this.$t("Personalbelongings"),
              path: "/Projct_Personalbelongings",
            },
          ],
        },
        {
          name: this.$t("services"),
          path: "/service",
          img: require("@/assets/img/tabfw.png"),
          children: [
            {
              name: this.$t("Bondedlogisticservice"),
              path: "/service_BondedPage",
            },
            {
              name: this.$t("WarehouseService"),
              path: "/service_Warehouse",
            },
            {
              name: this.$t("Supplychainservice"),
              path: "/service_Supply",
            },
            {
              name: this.$t("domestic"),
              path: "/service_CrossBorder",
            },
            {
              name: this.$t("Shipmentagencyservicesbylandseaandair"),
              path: "/service_Plane",
            },
          ],
        },
        {
          name: this.$t("aboutus"),
          path: "",
          img: require("@/assets/img/about_img.png"),
          children: [
            {
              name: this.$t("aboutus2"),
              path: "/companyintroduction",
              children: [],
            },
            {
              name: this.$t("joinus"),
              path: "/joinUs",
              children: [],
            },
            {
              name: this.$t("news"),
              path: "/newsPage",
              children: [],
            },
            {
              name: this.$t("contactus"),
              path: "/contactus",
              children: [],
            },
          ],
        },
        // {
        //   name: "新闻动态",
        //   path: "/newsinformation",
        //   children: []
        // },
        // {
        //   name: "公司介绍",
        //   path: "/companyintroduction",
        //   children: []
        // },
        // {
        //   name: "工作机会",
        //   path: "/jobchance",
        //   children: []
        // },
        // {
        //   name: "联系我们",
        //   path: "/contactus",
        //   children: []
        // }
      ],
    };
  },
  methods: {
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem("navIndex", index);
      this.menuName = name;
    },
    showmue() {
      this.showarea = true;
    },
    offmue() {
      this.showarea = false;
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
    selectI18(e) {
      console.log(e);
      if (e == "zh") {
        localStorage.setItem("locale", "zh");
        location.reload();
      } else {
        localStorage.setItem("locale", "en");
        location.reload();
      }
    },
  },
  created: function () {
    window.onload = function () {
      let btn2 = document.getElementById("btn2");
      let btn3 = document.getElementById("btn3");
      let btn4 = document.getElementById("btn4");
      let box = document.getElementById("box");
      btn2.onmouseover = (e) => {
        box.style.display = "block";
      };
      btn3.onmouseover = (e) => {
        box.style.display = "block";
      };
      btn4.onmouseover = (e) => {
        box.style.display = "block";
      };

      box.onmouseleave = () => {
        box.style.display = "none";
        $(".headerTitle li").removeClass("on");
      };
    };
  },
};
</script>
<style scoped>
/* 顶部 */
#header {
  background: #0062af;
  transition: all ease 0.6s;
}
#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}
/* 顶部的图标 */

#header .header-top span {
  margin: 0 8px;
}
/* 导航栏 */
#header .header-nav {
  height: 91px;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 100px;
  height: 100%;
  float: left;
  position: relative;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 193px;
  height: 90px;
  /* position: absolute; */
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}

#header .header-nav-right {
  float: right;
  line-height: 90px;
  padding: 0 10px;
}

.langli {
  color: #888;
  font-size: 10px;
}

.pickli {
  color: #fff;
  font-weight: bold;
  font-size: 14px;
}

/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  line-height: 90px;
  padding-left: 200px;
  float: left;
  margin: 0;
  max-width: 1000px;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 45px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #fff;
  font-size: 15px;
  font-weight: bold;
  padding: 35px 0;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 3px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #ffc500;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #ffc500;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #ffc500;
  text-decoration: none;
  border-bottom: 2px solid #ffc500;
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 100%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #ccc;
}
@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    height: 80px;
    position: relative;
  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 95px;
    height: 45px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #474747;
    position: relative;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #474747;
    z-index: 9999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }

  .navigation-down {
    position: absolute;
    top: 91px;
    left: 0px;
    width: 100%;
  }

  .navigation-down .nav-down-menu {
    width: 100%;
    height: 100px;
    margin: 0;
    background: #344157;
    position: absolute;
    top: 0px;
    z-index: 999;
  }
}

/* Descendant of .nav, Bootstrap specificity (shouldn't be like this) */
.nav > .dropdown-megamenu {
  position: static;
}
@media (max-width: 767px) {
  .navbar-nav .open .dropdown-container {
    position: static;
    float: none;
    width: auto;
    margin-top: 0;
    border: 0;
    box-shadow: none;
    border-radius: 0;
  }
}
.dropdown-megamenu > .dropdown-container {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  max-width: 100%;
  padding: 15px;
}
.dropdown-megamenu .dropdown-menu {
  display: block;
}
.link-image .media-object {
  float: left;
  margin-bottom: 7.5px;
}
.link-image-sm + .link-image-sm .media-object {
  margin-left: 7.5px;
}
.thumbnail .caption {
  min-height: 120px;
}
.thumbnail:hover {
  text-decoration: none;
}
/* Link list */
.list-links {
  list-style: none;
  padding: 0;
}
.list-links li {
  line-height: 1.71428571;
}
.list-links a {
  color: #555;
}
.list-links a:hover,
.list-links a:focus,
.list-links a:active {
  color: #22527b;
}
/* General styles to improve presentation */
html,
body {
  height: 100%;
  min-height: 500px;
}
body {
  background: linear-gradient(to bottom, #59a874 0, #449a63 100%);
}
.example-megamenu {
  width: 100%;
  max-width: 1140px;
  padding: 20px;
  margin: 0 auto;
}
h3 {
  font-family: "Open Sans", sans-serif;
  font-weight: bold;
  text-align: center;
  line-height: 1.3;
  margin-bottom: 2rem;
  color: #fff;
}

#box {
  display: block;
}

.dropDownArea {
  color: rgba(0, 0, 0, 0.8);
  position: relative;
  display: inline-block;
  color: #eee;
  font-size: 15px;
}

.dropDownArea.page:hover {
  color: rgba(0, 0, 0, 0.8);
  position: relative;
  display: inline-block;
  color: #eee;
  font-size: 15px;
  border-color: transparent !important;
}

.dropDownArea img {
  vertical-align: baseline !important;
}

.dropDownArea .myButton {
  display: inline-block;
  /*color: #FFF;*/
  font-size: 15px;
}

.dropDownArea {
  position: relative;
}

.showDropDownArea {
  display: none;
  display: block;
  z-index: 10;
}

.showDropDownArea {
  display: none;
  position: absolute;
  width: 100%;
  left: 0;
  top: 90px;
}

.showDropDownArea .contentArea {
  display: flex;
  box-sizing: content-box;
  width: 100%;
  height: 220px;
  background: #22517b90;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.06);
}

.item-cont {
  margin-left: 25%;
  margin-top: 20px;
}

.lie-item {
  padding: 0 45px;
  border-right: 1px solid #9292923b;
}

.hang-item {
  padding: 5px 0;
}

.text-div {
  color: #ffffff;
}

.cellLeftIcon img {
  width: 40px;
  height: 40px;
  border-radius: 10px;
}

.name-div {
  margin-top: 10px;
  color: #ffffff;
  font-size: 16px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue